import { FC, ReactNode } from 'react';
import { colors } from '@kontentino/ui';

interface Props {
  children: ReactNode;
}

const PdfPageStyle: FC<Props> = ({ children }) => (
  <>
    <style>
      {`
        body {
          background-color: ${colors.white};
          margin: 0;
        }
        @page {
          size: auto;
          margin: 1.3cm;
        }
      `}
    </style>
    {children}
  </>
);

export default PdfPageStyle;
